var map = {
	"./pic-01.png": "9238",
	"./pic-02.png": "5653",
	"./pic-Chiling.png": "e4c6",
	"./pic-ClaraZhou.png": "ce09",
	"./pic-DonTang.png": "d99b",
	"./pic-FannyZhang.png": "d151",
	"./pic-HaiwenZhou.png": "b69a",
	"./pic-JanusYeo.png": "474c",
	"./pic-LindsayZhao.png": "1362",
	"./pic-QuintusSu.png": "7c98",
	"./pic-RonnieLi.png": "dc05",
	"./pic-WanfengChen.png": "e701",
	"./pic-YuanitaTjia.png": "bb1a",
	"./pic-jinyue.png": "79a4",
	"./round.png": "07a9",
	"./team-banner.png": "3a65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "acbf";